import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COMMON } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React from "react";
import { css } from "styled-components";

const enum fields {
    sectionTitle = "sectionTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.sectionTitle]: string;
    };
}
type Props = OwnProps;

export interface CreateAccountFormStyles {
    titleText?: TypographyPresentationProps;
}

export const createAccountFormStyles: CreateAccountFormStyles = {
    titleText: {
        forwardAs: "h2",
        variant: "h3",
        css: css`
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        {
                            values: ["25px", "30px", "40px", null, null],
                            properties: ["margin-top"],
                        },
                    ],
                    mediaOptions.min,
                )}
            margin-bottom: 10px;
            &:first-child {
                margin-bottom: 10px;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            {
                                values: ["15px", "20px", "30px", null, null],
                                properties: ["margin-top"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
};

const styles = createAccountFormStyles;

const CreateAccountSectionTitle = ({ id, fields }: Props) => {
    return <Typography {...styles.titleText}>{fields.sectionTitle}</Typography>;
};

const widgetModule: WidgetModule = {
    component: CreateAccountSectionTitle,
    definition: {
        group: "Create Account",
        icon: "heading",
        displayName: "Section Title",
        fieldDefinitions: [
            {
                name: fields.sectionTitle,
                displayName: "Section Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
